import React from 'react'

import { Table } from '_zari/core'

const tableHeaderRows = [{ label: 'IMPORTE' }, { label: 'FASE' }, { label: 'PROYECTO' }, { label: '' }]

const DetalleTablaSection = ({ detalles, dispatch }) => {
  const clickEliminar = React.useCallback(
    ({ _idFila }) => {
      dispatch({ type: 'eliminar', payload: { _idFila } })
    },
    [dispatch]
  )

  const tableRowTemplate = React.useCallback(
    row => (
      <Table.Row key={row._idFila}>
        <Table.Cell>{row.importe || '--'}</Table.Cell>
        <Table.Cell>{row.infoCodigoPresupuesto || '--'}</Table.Cell>
        <Table.Cell>{row.infoProyecto || '--'}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item
                key='eliminar'
                handleClose={handleClose}
                onClick={e => clickEliminar({ _idFila: row._idFila })}
              >
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [clickEliminar]
  )

  return (
    <Table
      containerId='container-detallesnuevoasiento'
      filas={detalles}
      tablaDetalle
      headRows={tableHeaderRows}
      rowTemplate={tableRowTemplate}
    />
  )
}

export default React.memo(DetalleTablaSection)
